export default "__VITE_ASSET__Bxj1jYYH__"